import React from 'react'
import './Banner.scss'
import {BiSolidRightArrow} from "react-icons/bi"

const Banner = ({title, subtitle, image, underline}) => {
  return (
    <div id='banner-container'>
        <div
            className="banner"
            style={{
                backgroundImage: `url(${image})`,
                backgroundBlendMode: 'unset',
                position: 'relative',
            }}
        >
            {/* Dark gradient overlay for text legibility */}
            <div style={{
                position: 'absolute',
                inset: 0,
                background: 'linear-gradient(to top, rgba(2,29,83,0.85) 0%, rgba(2,29,83,0.45) 50%, rgba(0,0,0,0.25) 100%)',
            }} />

            <div className="banner-text" style={{ position: 'relative', zIndex: 1 }}>
                <h1 style={{
                    textShadow: '0 4px 24px rgba(0,0,0,0.7), 0 1px 4px rgba(0,0,0,0.9)',
                    letterSpacing: '3px',
                }}>
                    {title}
                </h1>

                {/* Red accent bar under title */}
                <div style={{ width: '60px', height: '4px', background: '#ed3137', borderRadius: '2px', marginTop: '-10px' }} />

                <div className="bottom" style={{ display: `${underline === "true" ? "none" : "flex"}`, alignItems: 'center', gap: '6px', background: 'rgba(0,0,0,0.35)', padding: '6px 16px', borderRadius: '999px', backdropFilter: 'blur(4px)' }}>
                    <BiSolidRightArrow style={{ color: '#ed3137', fontSize: '10px', flexShrink: 0 }} />
                    <span style={{ textShadow: '0 1px 4px rgba(0,0,0,0.8)', fontWeight: 500, letterSpacing: '0.5px' }}>{subtitle}</span>
                </div>

                <div className="underline-bottom" style={{ display: `${underline === "true" ? "block" : "none"}` }} />
            </div>
        </div>
    </div>
  )
}

export default Banner